import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import excerptHtml from 'excerpt-html';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 300,
    minHeight: 300,
    width: 'calc( 100% - 20px )',

    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    "& .MuiTypography-h5": {
      fontSize: 16,
      fontWeight: 'bold'
    }
  },
  top: {
    flexGrow: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    display: 'flex',
  }
}));

export default function JobCard(props) {
  const classes = useStyles();

  return (
    <Card className={classes.root} raised={false}>
      <CardActionArea className={classes.top} onClick={() => props.click(props.job.id)}>
        <CardContent>
          <Typography gutterBottom variant="h5" component="h2">
            {props.job.title}
          </Typography>
          <Typography variant='subtitle1' color='primary' display='block'>{props.job.location}</Typography>
          <Typography variant='caption' gutterBottom display='block'>{props.job.job_statuses_i18n.join(', ')}</Typography>
          <Typography variant='body1' display='block'>{excerptHtml(props.job.description, {pruneLength: 80})}</Typography>
        </CardContent>
      </CardActionArea>
      <CardActions>
        <Button size="small" color="primary" onClick={() => props.click(props.job.id)}>
          View and apply
        </Button>
      </CardActions>
    </Card>
  );
}
